import { createFeatureSelector, createSelector } from '@ngrx/store';

import { bossAdapter, BossState, stateName } from './state';

const getIsLoading = (state: BossState) => state.isLoading;
const getError = (state: BossState) => state.error;

const { selectAll } = bossAdapter.getSelectors();

export const selectBossState = createFeatureSelector<BossState>(stateName);

export const selectIsLoading = createSelector(selectBossState, getIsLoading);
export const selectIsError = createSelector(selectBossState, getError);
export const selectReports = createSelector(selectBossState, selectAll);
